module.exports = __webpack_public_path__ + "img/yunpian.99ff1d50.png";